import axios from 'axios';
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    console.log('📤 Request to:', config.url);
    console.log('🔑 Token from localStorage:', token ? `${token.substring(0, 20)}...` : 'NO TOKEN');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      console.log('✅ Added Authorization header');
    }
    return config;
  }, (error) => Promise.reject(error)
);
export default api;